import React from "react";
import Card from "components/card";


const MostAskQuestion = () => {
  const questions = [
    {
      question: "Property Tax Payment Deadlines",
      asked: 482,
      type: "up",
    },
    {
      question: "Garbage & Recycling Pickup Schedule",
      asked: 451,
      type: "up",
    },
    {
      question: "Parking Permits & Street Parking Rules",
      asked: 85,
      type: "down",
    },
    {
      question: "Upcoming Community Events & Festivals",
      asked: 72,
      type: "up",
    },
    {
      question: "Building Permits & Zoning Information",
      asked: 63,
      type: "neutral",
    },
    {
      question: "Public Works Service Requests (Potholes, Streetlights)",
      asked: 45,
      type: "up",
    },
    {
      question: "Snow Removal Routes & Winter Parking Bans",
      asked: 38,
      type: "down",
    },
    {
      question: "City Council Meeting Agendas & Minutes",
      asked: 38,
      type: "down",
    },
    {
      question: "Water Bill Payment & Service Issues",
      asked: 38,
      type: "down",
    },
    {
      question: "Pet Licensing & Animal Control",
      asked: 38,
      type: "down",
    },
  ];



  return (
    <Card extra="most-asked-questions-card">
      <div className="most-asked-questions-header">
        <h2>Top 10 Most Asked Questions</h2>
      </div>
      <ul className="most-asked-questions-list">
        {questions.map((item, index) => (
          <li key={index} className="question-item">
            <div className="question-number-container">
              <div className="question-number">{index + 1}</div>
            </div>
            <div className="question-details">
              <p className="question-text">{item.question}</p>
              <p className="question-asked-count">Asked {item.asked} times</p>
            </div>
          </li>
        ))}
      </ul>
    </Card>
  );
};

export default MostAskQuestion;
